export default "__VITE_ASSET__SgSkwi10__"